"use client";

import { useEffect, useState, type ReactNode } from "react";

// Gate cliente que solo renderiza los hijos si el hostname actual es el
// storefront público (dominio pelado o su equivalente en dev/test). Los
// paneles `gestion.*` y `comercio.*` NO deben cargar GA4 ni Meta Pixel:
//   1. No son experiencia de usuario final — el tráfico ahí es del
//      operador, contamina las métricas.
//   2. GA4 registraría cada request de admin como pageview y Meta
//      trackearía staff como "audience".
//
// Estrategia: server render devuelve `null` por default (SSR); en el
// primer mount cliente, seteamos state según hostname. Como los
// <Script> hijos usan `strategy="lazyOnload"`, se ejecutan después del
// event `load` del document — el gate ya se montó antes de eso, así
// que en admin nunca se descarga el script.
export default function StorefrontOnly({ children }: { children: ReactNode }) {
  const [isStorefront, setIsStorefront] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const host = window.location.hostname;
    const isAdmin = host.startsWith("gestion.") || host.startsWith("comercio.");
    setIsStorefront(!isAdmin);
  }, []);

  if (!isStorefront) return null;
  return <>{children}</>;
}
